import {
  CreatePerformanceAgreementTrainingRequestDocument,
  PerformanceCourseRequestWizardAgreementFragment,
  TrainingsTrainingRequestStatusEnum,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { WizardComponent } from 'modules/trainings/components/Shared/WizardComponent'
import { WizardData } from 'modules/trainings/components/Shared/WizardComponent/types'

interface CourseRequestWizardProps {
  onClose: () => void
  agreement: PerformanceCourseRequestWizardAgreementFragment
  fromCatalog?: boolean
}

const CourseRequestWizard = ({
  onClose,
  agreement,
  fromCatalog = true,
}: CourseRequestWizardProps) => {
  const targetEmployeeId = agreement.target?.access?.employee?.id
  const [createTrainingRequest] = useMutation(CreatePerformanceAgreementTrainingRequestDocument, {
    extractorFn: (data) => ({
      ...data.performanceMutations.addTrainingRequestPerformanceAgreement,
      errors: data.performanceMutations.addTrainingRequestPerformanceAgreement.errors || [],
    }),
  })

  const onSubmit = async (
    ...args: [TrainingsTrainingRequestStatusEnum?, WizardData?, boolean?]
  ) => {
    const [, data, isDraft] = args
    if (!data) return

    const result = await createTrainingRequest({
      variables: {
        agreementId: String(agreement.id),
        trainingNeed: String(data.trainingNeed),
        trainingComment: data.comments,
        trainingId: data.trainingId,
        trainingName: data.trainingName,
        providerName: data.providerName,
        cost: data.cost,
        duration: data.duration,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.training_requests.create.wrong'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: isDraft
          ? i18n.t('trainings.training_requests.create.success_messages.draft')
          : i18n.t('trainings.training_requests.create.success_messages.pending'),
      })
      onClose()
    }
  }

  return (
    <WizardComponent
      wizardConfig={{ fromCatalog, allowDraft: false }}
      actions={{ onClose, onSubmit }}
      employeeId={Number(targetEmployeeId)}
    />
  )
}

export default CourseRequestWizard
